import React, { useState } from 'react';
import styled from 'styled-components';
import getImageUrl, { IMGIX } from '@/utils/images';

const Wrapper = styled.div`
  justify-content: center;
  align-items: center;
`;

function Share({ productData, className }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const shareData = {
    title: productData.name,
    url: `https://www.theinside.com/products/${productData.slug}`
  };

  const handleClick = async () => {
    setLoading(true);
    setError(false);
    try {
      await navigator.share(shareData);
      setLoading(false);
    } catch (err) {
      setError(false);
      setLoading(false);
    }
  };
  return (
    <Wrapper className={className ? className : ''}>
      <ShareButton onClick={handleClick}>
        <img
          src={getImageUrl('icons/share.svg', IMGIX)}
          className="share-icon"
          alt="Share your design"
        />
        {loading && (
          <div
            style={{
              width: 15,
              height: 15,
              marginLeft: 5
            }}
            className="spinner-border"
            role="status"
          >
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </ShareButton>
      {error && (
        <small>Sorry, the share feature is not available on this browser</small>
      )}
    </Wrapper>
  );
}

export default Share;

const ShareButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: #6c6c6c;
  display: flex;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  justify-content: center;
  line-height: 23px;
  outline: none;

  .share-icon {
    margin-right: 5px;
  }
`;
